import angular from 'angular';
import '../shared.module';
import { truncate } from '../../core/helpers/string.helper';

angular.module('app.shared').filter('cpTruncate', () => (value, length) => truncate(value, length));
